import React, { FC } from 'react'
import { Box, Container, Grid } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { ModularLayout } from './types'

type ProductDetailsModularProps = {
  layout: ModularLayout
}

const StyledContainer = styled(Container)`
  ${s({
    pt: 6,
  })}
`

export const ProductDetailsModular: FC<ProductDetailsModularProps> = ({
  layout,
}) => (
  <Box data-testid="mp-find-product-details-modular" bgcolor="colorBlack00">
    <Box> {layout.top.map(module => module)}</Box>
    <StyledContainer limitWidth>
      <Grid>
        <Box
          width={{
            xs: 1,
            md: 0.5,
            xl: 0.6,
          }}
          pr={{ xs: 0, md: 8 }}
        >
          {layout.middleLeft.map(module => module)}
        </Box>
        <Box
          width={{
            xs: 1,
            md: 0.5,
            xl: 0.4,
          }}
        >
          {layout.middleRight.map(module => module)}
        </Box>
      </Grid>
    </StyledContainer>
    <Box> {layout.bottom.map(module => module)}</Box>
  </Box>
)
